<template>
  <div class="card card-content card--interactive text-center">
    <CommPopper
      v-if="canAlterResources"
      ref="comPopper"
    >
      <div
        slot="content"
        class=" flex flex-col"
      >
        <a
          v-can="'edit-resources'"
          @click.prevent="openEditModal"
          v-text="'Edit'"
        />
        <a
          v-if="disabled"
          v-can="'edit-resources'"
          @click.prevent="openEnableModal"
          v-text="'Enable'"
        />
        <a
          v-else
          v-can="'edit-resources'"
          @click.prevent="openDisableModal"
          v-text="'Disable'"
        />
        <a
          v-can="'delete-resources'"
          @click.prevent="openDeleteModal"
          v-text="'Delete'"
        />
      </div>
    </CommPopper>
    <div class="flex-item">
      <h6
        class="text-blue uppercase -mt-2 mb-4"
        v-text="'Link'"
      />
      <a
        v-if="icon !== 'default'"
        target="_self"
        :href="url"
      >
        <SimpleSVG
          v-if="icon"
          :filepath="`/svg/${icon}.svg`"
        />
      </a>
      <h3 class="mb-4">
        <a
          target="_blank"
          :href="url"
          v-text="title"
        />
      </h3>
    </div>
  </div>
</template>

<script type="text/babel">
import { SimpleSVG } from 'vue-simple-svg'
import CommPopper from 'Communication/Resources/assets/js/components/CommPopper'

export default {
  name: 'LinkCard',
  components: {
    CommPopper,
    SimpleSVG,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.link.attributes.icon
    },
    title() {
      return this.link.attributes.title
    },
    url() {
      return this.link.attributes.url
    },
    disabled() {
      return this.link.attributes.disabled
    },
    canAlterResources() {
      return this.$store.state.user.abilities.includes('edit-resources') ||
        this.$store.state.user.abilities.includes('delete-resources')
    },
  },
  methods: {
    hidePopper() {
      this.$refs.comPopper.close()
    },
    openDeleteModal() {
      this.$store.commit('resourceOpenDeleteLinkModal', this.link)

      this.hidePopper()
    },
    openDisableModal() {
      this.$store.commit('resourceOpenDisableLinkModal', this.link)

      this.hidePopper()
    },
    openEnableModal() {
      this.$store.commit('resourceOpenEnableLinkModal', this.link)

      this.hidePopper()
    },
    openEditModal() {
      this.$store.commit('resourceOpenEditLinkModal', this.link)

      this.hidePopper()
    },
  },
}
</script>
